<template>
  <div>
    <v-card>
      <v-card-title>
        Nuevo registro
      </v-card-title>

      <v-card-text>
        <text-input
          :form="form"
          :label="$t('admissions.form.first_name')"
          :value.sync="form.first_name"
          :v-errors="errors"
          name="first_name"
          v-validate="'required'"
        ></text-input>
        <text-input
          :form="form"
          :label="$t('admissions.form.last_name')"
          :value.sync="form.last_name"
          :v-errors="errors"
          name="last_name"
          v-validate="'required'"
        ></text-input>
        <text-input
          :form="form"
          :label="$t('admissions.form.nuip')"
          :value.sync="form.nuip"
          :v-errors="errors"
          name="nuip"
          v-validate="'required'"
        ></text-input>
        <date-picker
          :form="form"
          :label="$t('admissions.form.date_of_birth')"
          :v-errors="errors"
          :value.sync="form.date_of_birth"
          name="date_of_birth"
          v-validate="'required'"
          @input="verifyDate()"
        ></date-picker>
        <text-input
          :form="form"
          :label="$t('admissions.form.guardian1_first_name')"
          :value.sync="form.guardian1_first_name"
          :v-errors="errors"
          name="guardian1_first_name"
          v-validate="'required'"
        ></text-input>
        <text-input
          :form="form"
          :label="$t('admissions.form.guardian1_last_name')"
          :value.sync="form.guardian1_last_name"
          :v-errors="errors"
          name="guardian1_last_name"
          v-validate="'required'"
        ></text-input>
        <text-input
          :form="form"
          :label="$t('admissions.form.guardian1_cellphone')"
          :value.sync="form.guardian1_cellphone"
          :v-errors="errors"
          name="guardian1_cellphone"
          v-validate="'required'"
        ></text-input>
        <text-input
          :form="form"
          :label="$t('admissions.form.guardian1_email')"
          :value.sync="form.guardian1_email"
          :v-errors="errors"
          name="guardian1_email"
          v-validate="'required'"
        ></text-input>
        <v-textarea
          :form="form"
          v-model="form.notes"
          :v-errors="errors"
          outline
          label="Notas"
          name="notes"
        ></v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="$emit('closeModal')">Cancelar</v-btn>
          <v-btn
            color="primary"
            @click="register"
            :disabled="disabled_date"
          >{{$t('register')}}</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import axios from 'axios'
import Form from 'vform'
import moment from 'moment';

  export default {
    name: 'new-admissions-assistance-view',
    props: {
      setting_id: {
        type: Number,
        required: true,
      },
      meeting_id: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        form: new Form({
          first_name: '',
          last_name: '',
          nuip: '',
          date_of_birth: '',
          guardian1_first_name: '',
          guardian1_last_name: '',
          guardian1_cellphone: '',
          guardian1_email: '',
          notes: '',
          setting_id : '',
          meeting_id: '',
          assistance: true
        }),
        isLoading: false,
        settings: [],
        disabled_date: false
      }
    },
    created () {
      this.init()
    },
    methods: {
      async register () {
        if (await this.formHasErrors()) return

        this.form.setting_id = this.$props.setting_id
        this.form.meeting_id = this.$props.meeting_id

        // Register the user.
        this.form.post('/api/admissions/register')
          .then(resp => {
              if (resp.data.already_exists) {
                this.$store.dispatch('responseMessage', {
                    type: 'warning',
                    text: 'Ya existe un registro con el mismo número de identificación.',
                    modal: true
                })
              } else  {
                this.init()
                this.$emit('closeModal')
              }

          })
          .catch(err => {
            console.log(err.response)
          })
      },
      init() {
        axios.get('/api/admissions/cohort')
          .then(resp => {
            if (resp.status === 200) {
              this.settings = resp.data
              this.checkStatus()
            }
          })
          .catch(error => console.log(error))

        this.entries = []
        this.searchStudent= null
      },
      verifyDate() {
        if (moment(this.form.date_of_birth).isBefore(this.settings[0].birthdate1)) {
          this.disabled_date = true;
          this.$store.dispatch('responseMessage', {
              type: 'warning',
              text: 'Los procesos de admisiones para esta cohorte ya están cerrados. Si quiere estar en lista de espera puede contactar a admissions@columbus.edu.co',
              modal: true
          })
        } else if (moment(this.form.date_of_birth).isAfter(this.settings[0].birthdate2)) {
          this.disabled_date = true;
          this.$store.dispatch('responseMessage', {
              type: 'warning',
              text: 'Los procesos de admisiones para esta cohorte se harán en el futuro. Para más información contactar a admissions@columbus.edu.co',
              modal: true
          })
        } else {
          this.disabled_date = false;
          return true
        }
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/admissions/manage/new_assistance.vue